<!-- 代码已包含 CSS：使用 TailwindCSS , 安装 TailwindCSS 后方可看到布局样式效果 -->
<template>
  <div class="flex" style="align-items: none"> 
  <!-- 左侧面板 -->
  <div class="w-80 border-r border-gray-200">
  <!-- 客服切换区域 -->
  <div class="p-4 border-b border-gray-200">
  <div class="flex items-center space-x-3 mb-4 relative">
  <div class="relative">
  <img :src="currentAgent.avatarUrl" alt="客服头像" class="w-12 h-12 rounded-full object-cover">
  <div :class="['absolute bottom-0 right-0 w-3 h-3 rounded-full',
  currentAgent.is_online === 1 ? 'bg-green-500' : 'bg-gray-400']"></div>
  </div>
  <div class="flex-1">
  <h3 class="font-medium">{{ currentAgent.nickName }}</h3>
  <p class="text-sm text-gray-500">
                {{ 
                { 0: '未在线', 1: '在线', 2: '离开' }[currentAgent.is_online] || '未知状态' 
                }}
                </p>
  </div>
  <button @click="showAgentSelect = !showAgentSelect" class="text-gray-400 hover:text-gray-600 !rounded-button">
  <i class="fas fa-chevron-down"></i>
    切换客服
  </button>
  <!-- 客服选择下拉面板 -->
  <div v-if="showAgentSelect" class="absolute top-full right-0 mt-2 w-64 bg-white rounded-lg shadow-lg border border-gray-200 z-50">
      <div v-for="agent in agents" 
           :key="agent.id" 
           @click="selectAgent(agent)"
           class="p-3 hover:bg-gray-50 cursor-pointer flex items-center space-x-3">
          <div class="relative">
              <img :src="agent.avatarUrl" alt="客服头像" class="w-10 h-10 rounded-full object-cover">
              <div :class="['absolute bottom-0 right-0 w-2.5 h-2.5 rounded-full',
                  agent.status === 'online' ? 'bg-green-500' : 'bg-gray-400']"></div>
          </div>
          <div class="flex-1">
              <h4 class="font-medium">{{ agent.nickName }}</h4>
              <p class="text-sm text-gray-500">
                {{ 
                { 0: '未在线', 1: '在线', 2: '离开' }[agent.is_online] || '未知状态' 
                }}
                </p>
          </div>
      </div>
  </div>
  </div>
  <div class="flex space-x-2">
    <div class="flex space-x-2">
  <button 
    v-for="status in statusOptions"
    :key="status.value"
    @click="changeStatus(status.value)"
    :class="[
      'px-3 py-1 text-sm !rounded-button whitespace-nowrap',
      currentAgent.is_online === statusMap[status.value] 
        ? 'bg-blue-500 text-white' 
        : 'bg-gray-100 text-gray-600'
    ]">
    {{ status.label }}
  </button>
</div>
  </div>
  </div>
  <!-- 用户列表 -->
  <div class="flex-1 overflow-y-auto" style="height: 480px;">
  <div v-for="user in users"
  :key="user.id"
  @click="selectUser(user)"
  :class="[
  'p-4 hover:bg-gray-50 cursor-pointer',
  selectedUser.id === user.id ? 'bg-gray-50' : ''
  ]">
  <div class="flex items-center space-x-3">
  <img :src="user.receiver.avatarUrl" alt="用户头像" class="w-10 h-10 rounded-full object-cover">
  <div class="flex-1 min-w-0">
  <div class="flex justify-between items-center">
  <h4 class="font-medium truncate">{{ user.receiver.nickName }}</h4>
  <!-- <span class="text-xs text-gray-500">{{ user.lastMessageTime }}</span> -->
  </div>
  <!-- <p class="text-sm text-gray-500 truncate">{{ user.lastMessage }}</p> -->
  </div>
  </div>
  </div>
  </div>
  </div>
  <!-- 修改模板部分 -->
<!-- 消息容器部分 -->
<div class="flex-1 p-4" ref="messageContainer" style="height: 440px; z-index: 500; overflow-y: auto;">
  <div v-for="item in chatHistory.messages" 
       :key="item.id + item.mid" 
       class="mb-4">
    
    <!-- 系统消息 -->
    <div v-if="item.sender.user_id === 1" class="text-center text-gray-500 text-sm my-2">
      {{ item.message.content }}
    </div>

    <!-- 普通消息 -->
    <div v-else>
      <div :class="[
        'flex items-start',
        item.userid === currentAgent.user_id ? 'justify-end' : 'justify-start'
      ]">
        <!-- 消息主体容器 -->
        <div class="max-w-[70%] flex items-start gap-3" 
             :class="item.userid === currentAgent.user_id ? 'flex-row-reverse' : ''">
          
          <!-- 头像 -->
          <img :src="item.sender.avatarUrl || defaultAvatar"
               class="w-8 h-8 rounded-full object-cover flex-shrink-0">
          
          <!-- 消息内容 -->
          <div :class="[
            'p-3 rounded-lg',
            item.userid === currentAgent.user_id 
              ? 'bg-blue-500 text-white order-1' 
              : 'bg-gray-100 order-2'
          ]">
            <!-- 消息内容 -->
            <template v-if="item.type === 'text'">
              <div v-if="item.status === 'sending'" class="text-xs text-gray-400">
                <i class="fas fa-spinner fa-spin"></i>
              </div>
              <p>{{ item.message.content.replace(/^"+|"+$/g, '') }}</p>
            </template>

            <!-- 好友申请消息 -->
            <div v-else-if="item.type === 'aggreFriend'">
              <p>{{ item.message.content }}</p>
              <a :href="item.url" class="text-blue-400 hover:underline mt-1 block">
                查看新好友
              </a>
            </div>

            <!-- 时间与状态 -->
            <!-- <div :class="[
              'text-xs mt-1 flex items-center space-x-2',
              item.userid === currentAgent.user_id 
                ? 'text-blue-100 justify-end' 
                : 'text-gray-500 justify-start'
            ]">
              <span>{{ formatTime(item.create_time) }}</span>
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="border-t p-4" style="position: absolute; bottom: 50px; width: 725px;">
    <div class="flex space-x-3">
      <input
        v-model="message"
        @keyup.enter="message"
        placeholder="输入消息..."
        class="flex-1 p-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
      >
      <button
        @click="sendMessage"
        class="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 !rounded-button"
      >
        发送
      </button>
    </div>
  </div>
</div>
  <!-- 历史记录弹窗 -->
  <div v-if="showHistory" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
  <div class="bg-white rounded-lg w-2/3 h-3/4 flex" style="position: relative;">
    <!-- <div class="p-4 border-b border-gray-200 flex justify-between items-center">
    <h3 class="font-medium">聊天记录</h3>
    <button @click="showHistory = false" class="text-gray-600 hover:text-gray-800 !rounded-button whitespace-nowrap">
    <i class="fas fa-times"></i>
    </button>
    </div> -->
    <div>    
      <button @click="showHistory = false"  
      style="position: absolute;right: 10px;top: 10px;"
      class="text-gray-600 hover:text-gray-800 !rounded-button whitespace-nowrap">
    <i class="fas fa-times"></i>
    关闭
    </button>
  </div>
  <div class="flex-1 p-5" >
  <div v-for="record in chatHistory" :key="record.id" class="mb-4">
  <!-- <div class="text-center text-sm text-gray-500 mb-2">{{ record.date }}</div> -->
  <div v-for="message in record.messages"
  :key="message.id"
  class="mb-2 flex items-start space-x-3"
  :class="message.isSelf ? 'flex-row-reverse space-x-reverse' : ''">
  <img :src="message.avatarUrl" alt="头像" class="w-8 h-8 rounded-full object-cover">
  <div :class="[
  'max-w-[70%] p-3 rounded-lg',
  message.isSelf ? 'bg-blue-500 text-white' : 'bg-gray-100'
  ]">
  <p>{{ message.content }}</p>
  <span :class="[
  'text-xs mt-1 block',
  message.isSelf ? 'text-blue-100' : 'text-gray-500'
  ]">{{ message.time }}</span>
  </div>
  </div>
  </div>
  </div>
  </div>
  </div>
  </div>
  </template>
  <script>
  import UserApi from '@/api/user.js'
  const config = require('../../../../config');  // 根据项目路径调整
  export default {
    props: {
    list: {
      type: Object,
      default: () => ({ data: [] })
    },
    // currentUserId: {
    //   type: [Number, String],
    //   required: true
    // }
  },
  name: 'App',
  data() {
  return {
  showAgentSelect: false, // 控制客服选择面板的显示
  currentAgent: {},
  message: '', // 新增消息输入绑定
  agents: [
  ],
  statusMap: {  // 状态映射关系
      'offline': 0,
      'online': 1,
      'busy': 2
    },
    statusOptions: [
      { label: '在线', value: 'online' },
      { label: '离开', value: 'busy' },
      { label: '离线', value: 'offline' }
    ],
  users: [

  ],
  selectedUser: {},
  socket: null,
  newMessage: '',
  showHistory: false,
  chatHistory: [
  {
  date: '2024-01-20',
  messages: []
  }
  ],

  
  };
  },
  created() {
  this.selectedUser = this.users[0];
  UserApi.userlist({ role:'cservice'}).then(data => {
          console.log("user",data.data.list.data);
          this.agents = data.data.list.data
          this.currentAgent = data.data.list.data[0]
        })
        let id = 0
        if(this.currentAgent.user_id === undefined){
          id = 606
        }else {
          id = this.currentAgent.user_id
        }
        this.getMyFriend(id)
        this.getChatList(id)
        this.getMsgList( this.selectedUser.sender.user_id,this.selectedUser.receiver.user_id)
  },
  beforeDestroy() {
  // 组件销毁前关闭连接
  if (this.socket) this.socket.close();
},
  methods: {
    handleSocketOpen(event) {
    console.log('WebSocket 连接成功', event);
  },
  handleSocketMessage(event) {
    const receivedData = JSON.parse(event.data);
    this.messages.push(receivedData); // 将消息存入数组‌:ml-citation{ref="7" data="citationList"}
  },
  handleSocketError(error) {
    console.error('WebSocket 错误:', error);
  },
  handleSocketClose(event) {
    console.log('WebSocket 连接关闭', event);
  },
     // selectUser 方法
     async selectUser(user) {

   
      this.selectedUser = user;
      this.$forceUpdate();
      // 获取历史消息
      try {
        const res = await UserApi.getMsgList({
          userid:user.sender.user_id,  // 当前用户ID
          touid: user.receiver.user_id // 好友用户ID
        });
        
        // 直接替换整个数组（触发响应式）
    this.chatHistory.messages = res.data.list.data.map(msg => ({
      ...msg,
      isSelf: msg.userid === this.currentAgent.user_id
    }));

    
    this.$nextTick(() => {
      this.$forceUpdate(); // 仅在极端情况下使用（可选）
    });
        
      } catch (error) {
        console.error('获取消息失败:', error);
      }
    },
  changeStatus(statusValue) {
    this.currentAgent.is_online = this.statusMap[statusValue]
    UserApi.edituser({user_id: this.currentAgent.user_id,
      grade_id:this.currentAgent.grade.grade_id,
      is_online:this.statusMap[statusValue]}).then(data => {
         console.log("用户在线");
         
        })
  },
  selectAgent(agent) { 
  this.currentAgent = {...agent};
  // this.currentAgent.user_id
  console.log(this.currentAgent);
  this.showAgentSelect = false;
  // 更新消息中的客服头像
  this.messages = this.messages.map(msg => {
      if (msg.isSelf) {
          return { ...msg, avatar: agent.avatar };
      }
      return msg;
  });
  this.getMyFriend(this.currentAgent.user_id)
  },
  formatMessage(msg) {
    return {
      ...msg,
      isSelf: msg.userid === this.currentAgent.user_id,
      sender: {
        user_id: msg.userid,
        avatarUrl: msg.sender ? msg.sender.avatarUrl : this.defaultAvatar,
        nickName: msg.sender ? (msg.sender.nickName || '未知用户') : '未知用户'
      },
      receiver: {
        user_id: msg.touid,
        avatarUrl: msg.receiver ? msg.receiver.avatarUrl : this.defaultAvatar,
        nickName: msg.receiver ? (msg.receiver.nickName || '未知用户') : '未知用户'
      },
      message: {
        content: msg.content.replace(/^"+|"+$/g, ''),
        type: msg.type,
        url: msg.url
      }
    };
  },
  scrollToBottom() {
    this.$nextTick(() => {
      const container = this.$refs.messageContainer;
      if (container) {
        container.scrollTop = container.scrollHeight + 100;
      }
    });
  },
  // 格式化消息数据
  formatTime(timestamp) {
    if (!timestamp) return '';
    const date = new Date(typeof timestamp === 'string' ? 
      timestamp.replace(/-/g, '/') : 
      timestamp * 1000
    );
    
    return `${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`;
  },
// 优化后的发送方法
async sendMessage() {
    if (!this.message.trim()) return;

    // 生成临时消息ID
    const tempId = `temp_${Date.now()}_${Math.random().toString(36).substr(2, 5)}`;
    
    // 构建临时消息对象
    const tempMsg = {
      id: tempId,
      mid: tempId,
      userid: this.currentAgent.user_id,
      touid: this.selectedUser.receiver.user_id,
      type: "text",
      status: "sending", // 新增发送状态
      message: {
        content: this.message,
        type: "text",
        url: ""
      },
      create_time: new Date().getTime() / 1000, // 使用时间戳格式
      sender: {
        user_id: this.currentAgent.user_id,
        avatarUrl: this.currentAgent.avatarUrl,
        nickName: this.currentAgent.nickName
      },
      receiver: this.selectedUser.receiver
    };

    // 立即显示临时消息
    this.chatHistory.messages.push(tempMsg);
    this.scrollToBottom();

    try {
      // 发送WebSocket消息
      const wsMsg = {
        user_id: this.currentAgent.user_id,
        type: 'chat',
        msgtype: 'text',
        content: this.message,
        mid: tempId,
        to_user_id: this.selectedUser.receiver.user_id,
        obj: JSON.stringify({})
      };

      await this.initWebSocket();
      this.websocket.send(JSON.stringify(wsMsg));
      
      // 清空输入框
      this.message = '';
      
      // 5秒后检查消息状态
      setTimeout(() => {
        const index = this.chatHistory.messages.findIndex(m => m.id === tempId);
        if (index > -1 && this.chatHistory.messages[index].status === 'sending') {
          this.$set(this.chatHistory.messages[index], 'status', 'failed');
        }
      }, 5000);

    } catch (error) {
      console.error('发送失败:', error);
      const index = this.chatHistory.messages.findIndex(m => m.id === tempId);
      if (index > -1) {
        this.$set(this.chatHistory.messages[index], 'status', 'failed');
      }
    }
  },
       // 初始化 WebSocket 连接
       initWebSocket() {
  return new Promise((resolve, reject) => {
    // 如果已有连接且状态为 OPEN/CONNECTING，直接复用
    if (this.websocket && [WebSocket.OPEN, WebSocket.CONNECTING].includes(this.websocket.readyState)) {
      resolve();
      return;
    }

    const wsUrl = config.dev.socket;
    this.websocket = new WebSocket(wsUrl);
    this.websocket.onmessage = async (event) => {
        const response = JSON.parse(event.data);
        console.log('/监听消息')
        // 处理消息发送确认
        if (response.type === 'message_ack') {
          const index = this.chatHistory.messages.findIndex(
            m => m.mid === response.data.mid
          );
          
          if (index > -1) {
            // 替换临时消息为正式消息
            this.$set(this.chatHistory.messages, index, {
              ...this.chatHistory.messages[index],
              id: response.data.id,
              mid: undefined,
              status: 'sent',
              create_time: response.data.create_time
            });
          }
        }
        
        // 处理新消息
        if (response.type === 'new_message') {
          this.chatHistory.messages.push(this.formatMessage(response.data));
          this.scrollToBottom();
        }
      };


    this.websocket.onopen = () => {
      console.log('WebSocket 连接已建立');
      resolve(); // 连接成功时解析Promise
    };

    this.websocket.onerror = (error) => {
      console.error('WebSocket 错误:', error);
      reject(error); // 连接失败时拒绝Promise
    };

    this.websocket.onclose = () => {
      console.log('WebSocket 连接已关闭');
    };
   
    });
  },

  // selectUser(user) {
  //   console.log(user);
  //   // this.chatHistory.messages = []
  //   this.getMsgList(user.sender.user_id, user.receiver.user_id)
  // this.selectedUser = user;
  // this.initializeMessages();

  // },
  initializeMessages() {
  this.messages = [
  {
  id: 1,
  content: '您好，请问有什么可以帮助您的吗？',
  time: '14:30',
  isSelf: true,
  avatar: this.currentAgent.avatar
  },
  {
  id: 2,
  content: '你好，我想咨询一下产品的相关问题',
  time: '14:31',
  isSelf: false,
  avatar: this.selectedUser.avatar
  }
  ];
  },
  getMyFriend(id){
      UserApi.getMyFriend({touid:id}).then(data => {
        console.log("getMyFriend",data);
        data.data.list.data.shift() 
        this.users = data.data.list.data
        this.selectedUser = data.data.list.data[0]   
      }
      )
    },
    getChatList(id){
      UserApi.getChatList({touid:id,page:1}).then(data => {
        console.log("getChatList",data);
        // this.users = data.data.list.data    
      }
      )
    },
    async  getMsgList(userid, touid){
      // console.log("user_id",user_id);   //self
      // console.log("id",id);
      // UserApi.getMsgList({userid:user_id,touid:id}).then(data => {
      //   console.log("getMsgList",data);
      //   this.chatHistory.messages = data.data.list.data    
      // }
      // )

      try {
      const res = await UserApi.getMsgList({ userid, touid });
      // 使用Vue.set或修改原数组来触发响应式更新
      this.$set(this.chatHistory, 'messages', res.data.list.data.map(msg => ({
        ...msg,
        isSelf: msg.userid === this.currentAgent.user_id
      })));
      // 或者，如果chatHistory是一个响应式引用，可以直接替换数组
      // this.chatHistory.messages = [...]; // 注意这通常不会触发响应式更新，除非chatHistory本身是一个响应式引用
    } catch (error) {
      console.error('获取消息列表失败:', error);
    }
    },
  // sendMessage() {
  // if (!this.newMessage.trim()) return;
  // const message = {
  // id: Date.now(),
  // content: this.newMessage,
  // time: new Date().toLocaleTimeString('zh-CN', { hour: '2-digit', minute: '2-digit' }),
  // isSelf: true,
  // avatar: this.currentAgent.avatar
  // };
  // this.messages.push(message);
  // this.newMessage = '';
  // this.$nextTick(() => {
  // this.scrollToBottom();
  // });
  // },
  // scrollToBottom() {
  // const container = this.$refs.messageContainer;
  // container.scrollTop = container.scrollHeight;
  // },
  scrollToBottom() {
      this.$nextTick(() => {
        const container = this.$refs.messageContainer;
        container.scrollTop = container.scrollHeight + 100;
      });
    },
  canRevoke(message) {
  // 假设消息发送后 2 分钟内可撤回
  const messageTime = new Date(message.time);
  const now = new Date();
  return (now - messageTime) <= 120000; // 2分钟 = 120000毫秒
  },
  revokeMessage(messageId) {
  const index = this.messages.findIndex(m => m.id === messageId);
  if (index !== -1) {
  this.messages.splice(index, 1);
  }
  }
  }
  };
  </script>
  <style scoped>
  .custom-scrollbar {
  scrollbar-width: thin;
  scrollbar-color: #CBD5E0 #EDF2F7;
  }
  .custom-scrollbar::-webkit-scrollbar {
  width: 6px;
  }
  .custom-scrollbar::-webkit-scrollbar-track {
  background: #EDF2F7;
  }
  .custom-scrollbar::-webkit-scrollbar-thumb {
  background-color: #CBD5E0;
  border-radius: 3px;
  }
  input[type="text"] {
  font-size: 14px;
  }
  input[type="text"]::placeholder {
  color: #A0AEC0;
  }
  </style>
  


// WEBPACK FOOTER //
// src/views/service/index/chat.vue